import { z } from 'zod';
import { BroadcastChannel } from '../types/enums.js';
export const broadcastAudienceSchema = z.object({
    roles: z.array(z.string()).default([]),
    statuses: z.array(z.enum(['available', 'deployed', 'unavailable'])).default([]),
    projectIds: z.array(z.string().uuid()).default([]),
    coreOnly: z.boolean().default(false),
    rtwIssuesOnly: z.boolean().default(false),
});
export const sendBroadcastSchema = z.object({
    message: z.string().min(1).max(4000),
    templateId: z.string().nullable().optional(),
    audienceFilter: broadcastAudienceSchema,
    channels: z.array(z.nativeEnum(BroadcastChannel)).min(1),
});
export const saveTemplateSchema = z.object({
    name: z.string().min(1).max(120),
    message: z.string().min(1).max(4000),
});
//# sourceMappingURL=broadcast.js.map